// src/redux/branding/state.ts

export const type = 'branding';

// App-level default colours matching variables.css :root.
// Used when no tenant config is available.
export const DEFAULT_PRIMARY = '#006CA3';
export const DEFAULT_SECONDARY = '#0f97db';
export const DEFAULT_NEUTRAL = '#92949c'; // --ion-color-medium (fallback if secondary absent)

export interface BrandingState {
    name: string | null;
    logoUrl: string | null;
    primary: string;
    secondary: string;
    currencyPrefix: string;
    loaded: boolean;
    error: boolean;
    /**
     * A site-config request is currently in flight (drives the fetch-once
     * guard). Optional so existing partial-state test fixtures keep compiling;
     * absent is treated as "not fetching". initialState + the reducer always
     * set it concretely.
     */
    isFetching?: boolean;
}

export const initialState: BrandingState = {
    name: null,
    logoUrl: null,
    primary: DEFAULT_PRIMARY,
    secondary: DEFAULT_SECONDARY,
    currencyPrefix: '',
    loaded: false,
    error: false,
    isFetching: false,
};
